/*
 * DXBBQ · PDP media gallery — one-shot auto-advance
 * -------------------------------------------------
 * On product page load: after DELAY ms, advance the gallery to the 2nd slide.
 * If that slide is a video, it starts playing (muted). Then it never advances again.
 * Any user interaction before it fires (click / swipe) cancels the auto-advance.
 *
 * Theme: Flux by ManaThemes (Dawn-style media-gallery + slider-component).
 * Load only on the product template, with defer.
 */
(function () {
  'use strict';

  var DELAY = 2000;        // ms before the single auto-advance
  var SETTLE = 300;        // extra wait after DOM ready, lets Flux AOS finish
  var VIDEO_POLL = 150;    // ms between attempts to grab <video> from deferred-media
  var VIDEO_TRIES = 20;    // max attempts

  function init() {
    var gallery = document.querySelector('media-gallery');
    if (!gallery) return;

    var slider = gallery.querySelector('ul.product__media-list, ul.slider');
    var slides = Array.prototype.slice.call(
      gallery.querySelectorAll('li.product-media-item, li[data-media-id]')
    );
    if (slides.length < 2) return; // nothing to advance to

    function isVideo(li) {
      return !!li.querySelector(
        '.media-type-video, .media-type-external_video, .media-type-model, deferred-media, video'
      );
    }

    function goTo(li) {
      if (!li) return;
      if (typeof gallery.setActiveMedia === 'function') {
        gallery.setActiveMedia(li.dataset.mediaId, false);
      } else if (slider) {
        slider.scrollTo({ left: li.offsetLeft - slider.offsetLeft, behavior: 'smooth' });
        slides.forEach(function (s) {
          s.classList.remove('is-active');
          s.removeAttribute('aria-current');
        });
        li.classList.add('is-active');
        li.setAttribute('aria-current', 'true');
      }
    }

    function playVideoIn(li) {
      var deferred = li.querySelector('deferred-media');
      if (deferred && typeof deferred.loadContent === 'function' && !deferred.hasAttribute('loaded')) {
        try { deferred.loadContent(false); } catch (e) {}
      }
      var tries = 0;
      (function grab() {
        var v = li.querySelector('video');
        if (v) {
          v.muted = true;
          v.setAttribute('playsinline', '');
          var p = v.play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
        } else if (tries++ < VIDEO_TRIES) {
          setTimeout(grab, VIDEO_POLL);
        }
      })();
    }

    var done = false;
    var timer = null;

    function cancel() {
      done = true;
      clearTimeout(timer);
      cleanup();
    }

    function fire() {
      if (done) return;
      done = true;
      var second = slides[1];
      goTo(second);
      if (isVideo(second)) playVideoIn(second);
      cleanup();
    }

    function cleanup() {
      gallery.removeEventListener('click', cancel);
      if (slider) slider.removeEventListener('touchstart', cancel);
    }

    // Any interaction before firing cancels the auto-advance.
    gallery.addEventListener('click', cancel);
    if (slider) slider.addEventListener('touchstart', cancel, { passive: true });

    timer = setTimeout(fire, DELAY);
  }

  function ready() {
    // Wait for the media-gallery custom element to be defined, then settle for AOS.
    var start = function () { setTimeout(init, SETTLE); };
    if (window.customElements && customElements.whenDefined) {
      customElements.whenDefined('media-gallery').then(start).catch(start);
      // Fallback in case the element name differs / never upgrades.
      setTimeout(start, 1500);
    } else {
      start();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready);
  } else {
    ready();
  }
})();